module.exports = __webpack_public_path__ + "895d3c93052fd895cd3f34002cc43e6a.svg";